import {
  DefaultPage,
  ExternalDbEdit,
  XanodataSource,
  XanoDatabaseList,
  XanoCollectionsList,
  XanoTableSchema,
  AppwriteEdit,
  AppwriteCollectionUpdate,
  AppwriteDataSourceCreate,
  AppwriteDatabaseCollections,
  AppwriteDatabaseList,
  AppwriteCollectionsCreate,
  XataDatasource,
  XataWorkspacesList,
  XataDatabasesList,
  XataTableCreation,
  XataCollectionCreate,
  SupabaseDataList,
  SupabaseCollectionList,
  SupabaseSchema,
  SupabaseEdit,
  SupabaseUpdateCollection,
  XataEditPage,
  XataTableUpdate,
  DirectusDatasource,
  DirectusCollections,
  DirectusCollectionsCreate,
  DirectusEditPage,
  DirectusCollectionsUpdate,
  AirtableDataSource,
  AirtableWorkspaces,
  AirtableCollectionsList,
  AirtableCollectionCreate,
  AirtableEditPage,
  AirtableCollectionsUpdate,
  SalesForceDataSource,
  SalesForceCollectionsList,
  SalesForceCollectionsCreate,
  SalesForceUpdatePage,
  SalesforceCollectionUpdate,
  XanoEditPage,
  MySqlDataSourceCreate,
  MySqlCollections,
  MySqlCollectionsCreate,
  MySqlDataSourceEdit,
  MySqlCollectionsUpdate,
} from './';

export default {
  path: 'data-connector/:version/v',
  name: 'Data connector',
  childRoutes: [
    { path: ':projectId', name: 'Default page', component: DefaultPage, isPrivate: true },
    {
      path: ':projectId/external-database-edit/:dbUuid',
      name: 'External data base edit',
      component: ExternalDbEdit,
      isPrivate: true,
    },
    {
      path: ':projectId/update-page/:dbUuid',
      name: 'XanoEditPage',
      component: XanoEditPage,
      isPrivate: true,
    },
    {
      path: ':projectId/xano-data-source',
      name: 'Xanodata source',
      component: XanodataSource,
      isPrivate: true,
    },
    {
      path: ':projectId/xano-database-list',
      name: 'Xano database list',
      component: XanoDatabaseList,
      isPrivate: true,
    },
    {
      path: ':projectId/xano-collections-list',
      name: 'Xano collections list',
      component: XanoCollectionsList,
      isPrivate: true,
    },
    {
      path: ':projectId/xano-table-schema/:dbUuid',
      name: 'Xano table schema',
      component: XanoTableSchema,
      isPrivate: true,
    },
    {
      path: ':projectId/appwrite-edit/:dbUuid',
      name: 'Appwrite edit',
      component: AppwriteEdit,
      isPrivate: true,
    },
    {
      path: ':projectId/appwrite-edit/:dbUuid/update/:collectionId',
      name: 'Appwrite collection update',
      component: AppwriteCollectionUpdate,
      isPrivate: true,
    },
    {
      path: ':projectId/appwrite-datasource/list',
      name: 'Appwrite database list',
      component: AppwriteDatabaseList,
      isPrivate: true,
    },
    {
      path: ':projectId/appwrite-datasource/:externalDbUuid',
      name: 'Appwrite database collections',
      component: AppwriteDatabaseCollections,
      isPrivate: true,
    },
    {
      path: ':projectId/appwrite-datasource/:externalDbUuid/create',
      name: 'Appwrite collections create',
      component: AppwriteCollectionsCreate,
      isPrivate: true,
    },
    {
      path: ':projectId/appwrite-datasource',
      name: 'Appwrite data source create',
      component: AppwriteDataSourceCreate,
      isPrivate: true,
    },
    {
      path: ':projectId/supabase-datasource',
      name: 'Supabase data list',
      component: SupabaseDataList,
      isPrivate: true,
    },
    {
      path: ':projectId/supabase-collectionlist/:dbUuid',
      name: 'Supabase collection list',
      component: SupabaseCollectionList,
      isPrivate: true,
    },
    {
      path: ':projectId/supabase-schema/:dbUuid',
      name: 'Supabase schema',
      component: SupabaseSchema,
      isPrivate: true,
    },
    {
      path: ':projectId/supabase-edit/:dbUuid',
      name: 'Supabase edit',
      component: SupabaseEdit,
      isPrivate: true,
    },
    {
      path: ':projectId/supabase-update-collection/:collectionIdx/:dbUuid',
      name: 'Supabase update collection',
      component: SupabaseUpdateCollection,
      isPrivate: true,
    },
    {
      path: ':projectId/xata-datasource',
      name: 'Xata datasource',
      component: XataDatasource,
      isPrivate: true,
    },
    {
      path: ':projectId/xata-workspaces',
      name: 'Xata workspaces list',
      component: XataWorkspacesList,
      isPrivate: true,
    },
    {
      path: ':projectId/xata-databases',
      name: 'Xata databases list',
      component: XataDatabasesList,
      isPrivate: true,
    },
    {
      path: ':projectId/xata/:dbUuid',
      name: 'Xata table creation',
      component: XataTableCreation,
      isPrivate: true,
    },
    {
      path: ':projectId/xata/:dbUuid/:tableName',
      name: 'Xata collection create',
      component: XataCollectionCreate,
      isPrivate: true,
    },
    {
      path: ':projectId/xata-edit/:dbUuid',
      name: 'Xata edit page',
      component: XataEditPage,
      isPrivate: true,
    },
    {
      path: ':projectId/xata/:dbUuid/:tableName/update',
      name: 'Xata table update',
      component: XataTableUpdate,
      isPrivate: true,
    },
    {
      path: ':projectId/directus-datasource',
      name: 'Directus datasource',
      component: DirectusDatasource,
      isPrivate: true,
    },
    {
      path: ':projectId/directus-datasource/:externalDbUuid',
      name: 'Directus collections',
      component: DirectusCollections,
      isPrivate: true,
    },
    {
      path: ':projectId/directus-datasource/:externalDbUuid/create',
      name: 'Directus collections create',
      component: DirectusCollectionsCreate,
      isPrivate: true,
    },
    {
      path: ':projectId/directus-edit/:dbUuid',
      name: 'Directus edit page',
      component: DirectusEditPage,
      isPrivate: true,
    },
    {
      path: ':projectId/directus-edit/:externalDbUuid/update/:tableName',
      name: 'Directus collections update',
      component: DirectusCollectionsUpdate,
      isPrivate: true,
    },
    {
      path: ':projectId/airtable-datasource',
      name: 'Airtable data source',
      component: AirtableDataSource,
      isPrivate: true,
    },
    {
      path: ':projectId/airtable-workspaces',
      name: 'Airtable workspaces',
      component: AirtableWorkspaces,
      isPrivate: true,
    },
    {
      path: ':projectId/airtable-datasource/:externalDbUuid',
      name: 'Airtable collections list',
      component: AirtableCollectionsList,
      isPrivate: true,
    },
    {
      path: ':projectId/airtable-datasource/:externalDbUuid/create',
      name: 'Airtable collection create',
      component: AirtableCollectionCreate,
      isPrivate: true,
    },
    {
      path: ':projectId/airtable-edit/:externalDbUuid',
      name: 'Airtable edit page',
      component: AirtableEditPage,
      isPrivate: true,
    },
    {
      path: ':projectId/airtable-edit/:externalDbUuid/update/:collectionId',
      name: 'Airtable collections update',
      component: AirtableCollectionsUpdate,
      isPrivate: true,
    },
    {
      path: ':projectId/salesforce-datasource',
      name: 'Salesforce data source',
      component: SalesForceDataSource,
      isPrivate: true,
    },
    {
      path: ':projectId/salesforce-datasource/:externalDbUuid',
      name: 'Sales force collections list',
      component: SalesForceCollectionsList,
      isPrivate: true,
    },
    {
      path: ':projectId/salesforce-datasource/:externalDbUuid/create',
      name: 'Sales force collections create',
      component: SalesForceCollectionsCreate,
      isPrivate: true,
    },
    {
      path: ':projectId/salesforce-update/:externalDbUuid',
      name: 'Sales force update page',
      component: SalesForceUpdatePage,
      isPrivate: true,
    },
    {
      path: ':projectId/salesforce-update/:externalDbUuid/update/:tableName',
      name: 'Salesforce collection update',
      component: SalesforceCollectionUpdate,
      isPrivate: true,
    },
    {
      path: ':projectId/mysql-datasource',
      name: 'MySQL Data Source Create',
      component: MySqlDataSourceCreate,
      isPrivate: true,
    },
    {
      path: ':projectId/mysql-datasource/:dbUuid',
      name: 'MySQL Collection List',
      component: MySqlCollections,
      isPrivate: true,
    },
    {
      path: ':projectId/mysql-datasource/:dbUuid/create',
      name: 'MySQL Collections Create',
      component: MySqlCollectionsCreate,
      isPrivate: true,
    },
    {
      path: ':projectId/mysql-datasource/:dbUuid/edit',
      name: 'MySQL Collection List Edit',
      component: MySqlDataSourceEdit,
      isPrivate: true,
    },
    {
      path: ':projectId/mysql-datasource/:dbUuid/update/:tableName',
      name: 'MySQL Collection Update',
      component: MySqlCollectionsUpdate,
      isPrivate: true,
    },
  ],
};
